module.exports = __webpack_public_path__ + "src/assets/img/page5/1f8b1ac82504307510149231e6559e17.png";